export default "__VITE_ASSET__V7Z0PIod__"